module.exports = __webpack_public_path__ + "img/img-scene-3.6347c895.jpg";